export class InvitationManagementError extends Error {
    constructor(message) {
        super('Invitation operation failed: ' + message);
    }
}
